import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchchartoutput'
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], searchmetric:string): any[] {
    if(!items || !searchmetric){
      return items;
    };
    searchmetric=searchmetric.toLowerCase();
    return items.filter((item:any) => 
      item.option?.toLowerCase().includes(searchmetric));
  }

}
